import { render } from "./SignupBody.vue?vue&type=template&id=316212bb&scoped=true"
import script from "./SignupBody.vue?vue&type=script&lang=js"
export * from "./SignupBody.vue?vue&type=script&lang=js"

import "./SignupBody.vue?vue&type=style&index=0&id=316212bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316212bb"]])

export default __exports__